import type { PageHeaderTabsProps } from "./types-tabs";
import { useTabs } from "./use-tabs";
import { PageHeaderTabsView } from "./view-tabs";

export function PageHeaderTabs(props: PageHeaderTabsProps) {
  const viewModel = useTabs(props);

  return <PageHeaderTabsView {...viewModel} />;
}
PageHeaderTabs.displayName = "PageHeader.Tabs";
